import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { MarvDateService } from '@marv/services';
import {ApiService, LocalstorageService } from '@app/services';

export class LanguagesReponse{    
    id_language: number;
    name: string;
    icone: string;
    short_code: string;
}

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {
    
    apiService: ApiService;
    defaultLanguage: string = 'fr';
    actualLanguage: LanguagesReponse;
    languages: LanguagesReponse[] = [];
    isInitialized: boolean = false;
    
    constructor(
        private translateService: TranslateService,
        private localstorageService: LocalstorageService
    ) { }
    
    async init (apiService: ApiService){            
        if(!this.isInitialized){
            this.isInitialized = true;
            this.apiService = apiService;

            await this.getActivesLanguages();

            let language = this.localstorageService.get('language');  
            if(language === null){      
                language = this.translateService.getBrowserLang();     
                if(language === undefined){
                    language = this.defaultLanguage;
                }
            }

            this.languages.forEach((l) => {
                if(l.short_code === language){
                    this.actualLanguage = l;
                    return;
                }
            });

            let langShortCode = (this.actualLanguage ? this.actualLanguage.short_code : this.defaultLanguage);
            MarvDateService.SetMomentLocale(langShortCode);
            this.translateService.setDefaultLang(langShortCode);        
        }
    }
    
    translate(key: string|null): string{
        let text = '';
        if(key !== null && key != ''){
            text = this.translateService.instant(key);
        }        
        return text;
    }
    
    async getActivesLanguages(){
        this.languages = [{
            id_language: 1,
            name: 'Français',
            icone: '',
            short_code: 'fr'
        },{
            id_language: 2,
            name: 'Anglais',
            icone: '',
            short_code: 'en'
        }];
        /*
        let response = await this.apiService.get('languages/actives');     
        if(response && response.data){
            this.languages = response.data;
        }
        */
    }
    
    async changeLanguage(newLanguage: LanguagesReponse, reload: boolean = true){
        this.actualLanguage = newLanguage;
        this.translateService.use(this.actualLanguage.short_code);
        this.localstorageService.set('language', this.actualLanguage.short_code);        
        if(reload){
            window.location.reload();
        }
    }
    
    getMonths() : Array<string>{
        return [
            this.translate('MONTH_JANUARY'),
            this.translate('MONTH_FEBRUARY'),
            this.translate('MONTH_MARCH'),
            this.translate('MONTH_APRIL'),
            this.translate('MONTH_MAY'),
            this.translate('MONTH_JUNE'),
            this.translate('MONTH_JULY'),
            this.translate('MONTH_AUGUST'),
            this.translate('MONTH_SEPTEMBER'),
            this.translate('MONTH_OCTOBER'),
            this.translate('MONTH_NOVEMBER'),
            this.translate('MONTH_DECEMBER')
        ];
    }
    
    getShortsMonths() : Array<string>{
        return [
            this.translate('MONTH_SHORT_JANUARY'),
            this.translate('MONTH_SHORT_FEBRUARY'),
            this.translate('MONTH_SHORT_MARCH'),
            this.translate('MONTH_SHORT_APRIL'),
            this.translate('MONTH_SHORT_MAY'),
            this.translate('MONTH_SHORT_JUNE'),
            this.translate('MONTH_SHORT_JULY'),
            this.translate('MONTH_SHORT_AUGUST'),
            this.translate('MONTH_SHORT_SEPTEMBER'),
            this.translate('MONTH_SHORT_OCTOBER'),
            this.translate('MONTH_SHORT_NOVEMBER'),
            this.translate('MONTH_SHORT_DECEMBER')
        ];
    }
    
    getDays() : Array<string>{
        return [
            this.translate('DAY_SUNDAY'),
            this.translate('DAY_MONDAY'),
            this.translate('DAY_TUESDAY'),
            this.translate('DAY_WEDNESDAY'),
            this.translate('DAY_THURSDAY'),
            this.translate('DAY_FRIDAY'),
            this.translate('DAY_SATERDAY')
        ];
    }
    
    getShortsDays() : Array<string>{
        return [
            this.translate('DAY_SHORT_SUNDAY'),
            this.translate('DAY_SHORT_MONDAY'),
            this.translate('DAY_SHORT_TUESDAY'),
            this.translate('DAY_SHORT_WEDNESDAY'),
            this.translate('DAY_SHORT_THURSDAY'),
            this.translate('DAY_SHORT_FRIDAY'),
            this.translate('DAY_SHORT_SATERDAY')
        ];
    }
}
